import React, { useState, useEffect } from "react";
import { Prompt, useHistory, useParams } from "react-router-dom";

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import { Toast } from "../../shared/toaster/Toaster";
import Spinner from "../../shared/spinner/Spinner";

import FinishModal from "../layout/Modals/FinishModal";

import Auth from "../../auth/Auth";
// import AppContext from "../../shared/AppContext";

function Payment_Details(props) {
  // const { setCompanyInfo } = useContext(AppContext);

  const [isLoading, setLoading] = useState(false);
  const [openModel, setOpenModal] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });

  const route = useHistory();
  const { orderId } = useParams();

  const [isComponentMounted, setIsComponentMounted] = useState(false);

  //validation of card holder name

  //form submit code

  const formSubmitHandler = async () => {
    setLoading(true);
    // API hit
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/paypal/pay`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",

        "x-token": Auth.getToken(),
      },
      body: JSON.stringify({
        id: props.match.params.orderId

      }),
    });

    if (res.status >= 200 && res.status <= 299) {
      // setOpenModal(true);
      const data = await res.json();
      window.open(`${data.orderDetail.links[1].href}`, "_self");
      setIsComponentMounted(false);

      // SetToaster({
      //   show: true,
      //   type: "Success", // type should be "danger" or "success"
      //   content: data.message,
      // });
    }

    if (res.status >= 400 && res.status <= 499) {
      const data = await res.json();

      SetToaster({
        show: true,
        type: "danger",
        content: data.message,
      });
      setLoading(true);
    }
  };

  useEffect(() => {
    setIsComponentMounted(true);

    // window.onbeforeunload = function () {
    //   return "Payment will be cancel if you leave the page!";
    // };

    if (!props.location.state) {
      route.push(`/CartDetails/${orderId}`);
    }

    // return () => {
    //   window.onbeforeunload = function () {
    //     return;
    //   };
    // };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isLoading ? <Spinner /> : null}

      <Prompt
        message="Payment will be cancel if you leave the page!"
        when={isComponentMounted}
      />

      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />
      <div className="container payment_det_height">
        <div className="payment_details">
          {/* <div className="heading_top">
            <h2 className="payment_details_heading">Payment Details</h2>
          </div> */}
          <div className="payment_container row">
            <div className="col-lg-12">
              <div className="new_card">
                <div className="new_card_wrapper">
                  <div className="heading_top">
                    <h3 className="payment_details_subheading">Complete your payment</h3>
                  </div>
                  <button
                    className="active blue-bg w-40"
                    color="primary"
                    onClick={() => formSubmitHandler()}
                  >
                    Pay with paypal
                  </button>
                  {/* <StripeProvider stripe={stripe}> */}
                  {/* <form
                    action="#"
                    className="newcard_form"
                    onSubmit={formSubmitHandler}
                  > */}
                  {/* <div className="row">
                        <div className="col-lg-6">
                          <div className="input_fill">
                            <label htmlFor="#">Card Holder</label>
                            <input
                              type="text"
                              className="card_holder"
                         
                              {...bindField("holderName")}
                              placeholder="Enter name"
                            />
                            {errors.holderName && (
                              <p className="text-danger">{errors.holderName}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="input_fill top_mobile">
                            <label htmlFor="#">Card Number</label>
                            <div className="cardnumber">
                              <img
                                src={CardNumber}
                                alt="Card Nunber"
                                className="cardnumber_img"
                              />
                              <CardNumberElement options={CARD_OPTIONS} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row custom-top-margin">
                        <div className="col-lg-6">
                          <div className="input_fill row ">
                            <div className="col-lg-8">
                              <div className="input_fill_left">
                                <label htmlFor="#">Expiry Date</label>
                                <div className="cardexpiry">
                                  <img
                                    src={ExpiryDate}
                                    alt="expriry icon"
                                    className="cardexpiry_img"
                                  />
                                  <CardExpiryElement options={CARD_OPTIONS} />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input_fill_right">
                                <label htmlFor="#">CVV</label>
                                <div className="cardcvc">
                                  <CardCvcElement options={CARD_OPTIONS} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="payment_new_card-btn">
                            <button type="submit" className="active blue-bg">
                              Pay <strong>$ {props?.location?.state?.toFixed(2)}</strong>
                            </button>
                          </div>
                        </div>
                      </div> */}

                  {/* <PayPalScriptProvider
                    options={{
                      "client-id":`${process.env.REACT_APP_PAYPAL_CLIENT_ID}`
                    }}
                  >
                    <PayPalButtons
                      style={{ layout: "horizontal", label: "subscribe" }}
                      // fundingSource="card"
                      onApprove={(data, actions) => {
                        console.log("data", data);
                        if (data) {
                          formSubmitHandler(data.orderID);
                          // SetToaster({
                          //   show: true,
                          //   type: "Success", // type should be "danger" or "success"
                          //   content: "Payment Successfully",
                          // });
                          localStorage.removeItem("totalPaid");
                        }
                      }}
                      createOrder={(data, actions) => {
                        console.log(data, actions, "createOrder");
                        return actions.order.create({
                          purchase_units: [
                            {
                              amount: {
                                value: `${props?.location.state.toFixed(2)}`,
                              },
                            },
                          ],
                        });
                      }}
                    />
                  </PayPalScriptProvider> */}
                  {/* </form> */}
                  {/* </ iProvider> */}
                </div>
              </div>
            </div>

            {openModel && <FinishModal closeModal={setOpenModal} />}

            {/* <div className="col-lg-5">
            <div className="saved_cards">
              <div className="saved_cards_wrapper">
                <div className="heading_top">
                  <h3 className="payment_details_subheading">Saved Cards</h3>
                </div>
                <div className="saved_cards_box">
                  <a href="#!">
                    <h4 className="everyday_color top_heading">
                      Barry Johnson
                    </h4>
                    <div className="middle_section d-flex">
                      <div className="img_container">
                        <img src={ChipCardIcon} alt="wpfsim-card-chip" />
                      </div>
                      <div className="img_align_txt">
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">2345</span>
                      </div>
                    </div>
                    <div className="bottom_section_card d-flex">
                      <div className="cards_date">11/22</div>
                      <div className="img_container">
                        <img src={MasterCardIcon} alt="" />
                      </div>
                    </div>
                  </a>
                </div>
                <div className="saved_cards_box">
                  <a href="#!">
                    <h4 className="everyday_color top_heading">
                      Barry Johnson
                    </h4>
                    <div className="middle_section d-flex">
                      <div className="img_container">
                        <img src={ChipCardIcon} alt="wpfsim-card-chip" />
                      </div>
                      <div className="img_align_txt">
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">&bull;&bull;&bull;</span>
                        <span className="dots">2345</span>
                      </div>
                    </div>
                    <div className="bottom_section_card d-flex">
                      <div className="cards_date">11/22</div>
                      <div className="img_container">
                        <img src={MasterCardIcon} alt="" />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Payment_Details;
